/*
 *  Element,el-dialog弹出层拖拽及拉伸、双击全屏
 */
export default {
  inserted(el, binding, vnode) {
    el.querySelector("input").focus();
    el.querySelector("input").select();
  }
};



// WEBPACK FOOTER //
// ./src/plugins/directive/focus.js